// Sidebar imports
import {
  UilEstate,
  UilClipboardAlt,
  UilUsersAlt,
  UilPackage,
} from "@iconscout/react-unicons";



// Sidebar Data
export const SidebarData = [
  {
  icon: UilEstate,
  heading: "Dashboard",
  to:"/"
},
  {
  icon: UilClipboardAlt,
  heading: "Orders",
  to:"/orders"
},
  {
  icon: UilUsersAlt,
  heading: "Customers",
  to:"/customers"

},
  {
  icon: UilPackage,
  heading: "Products",
  to:"/product"

},
 
];
